'use client';
import { createStyles, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const typographyVariation = {
    sizes: {
        xs1: [
            10,
            14
        ],
        sm1: [
            12,
            16
        ],
        md1: [
            12,
            16
        ]
    }
};
var useStyles = createStyles((theme, { states, state, color }, { size })=>{
    const stateParams = states == null ? void 0 : states[state != null ? state : 'default'];
    var _ref;
    const _color = (_ref = color != null ? color : stateParams == null ? void 0 : stateParams.color) != null ? _ref : theme.palette.text.secondary;
    return {
        hint: _extends({}, theme.fn.typography({
            size,
            variant: typographyVariation,
            color: _color,
            weight: state === 'default' ? 'regular' : 'medium'
        }), {
            wordBreak: 'break-word',
            display: 'block',
            padding: rem('0 2')
        })
    };
});

export { useStyles as default };
//# sourceMappingURL=InputHint.styles.js.map
